<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xs pt-0>
        <v-layout row wrap justify-end align-center>
            <v-flex xs12 md2>
                <v-text-field
                    v-model="search"
                    prepend-icon="search"
                    label="Tìm kiếm"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
                <v-menu
                    :close-on-content-click="false"
                    v-model="menu_month_picker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :disabled="loading.submit"
                >
                    <v-text-field
                        slot="activator"
                        v-model="chosen_month"
                        label="Chọn tháng"
                        :disabled="loading.submit"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker min="2019-10" locale="vi-VI" type="month" v-model="chosen_month" @input="menu_month_picker = false"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 md2>
                <v-select
                    label="Tòa nhà"
                    v-model="chosen_building"
                    :items="list_building"
                    prepend-icon="domain"
                    required
                ></v-select>
            </v-flex>

            <v-flex xs12 md2>
                <v-btn
                    :loading="loading.submit || loader || export_csv.loading"
                    :disabled="loading.submit || loader"
                    @click="exportCSV" color="green" class="white--text"
                >XUẤT EXCEL</v-btn>
                <export-csv-button
                    :trigger="export_csv.trigger"
                    :title="export_csv.title"
                    :rows="export_csv.rows"
                ></export-csv-button>
            </v-flex>

            <v-flex xs12 md2>
                <v-btn
                    :loading="loading.submit || loader"
                    :disabled="loading.submit || loader"
                    @click="showPrintTab"
                    color="primary"
                >
                    <v-icon small left>print</v-icon>
                    In số {{ type_text }}
                </v-btn>
            </v-flex>

            <v-flex xs12 md2 v-if="role === 'admin'">
                <v-btn
                    :loading="loading.submit || loader"
                    :disabled="loading.submit || loader"
                    class="white--text"
                    @click="$refs.inputUpload.click()" color="green">
                    Nhập excel (admin)
                </v-btn>
                <input v-show="false" ref="inputUpload" type="file" @change="onFileSelected" >
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :loading="loader"
                        disable-initial-sort
                        :headers="headers"
                        :search="search"
                        :items="items" item-key="id" :rows-per-page-items="rowPerPage">
                        <template #headers="props">
                            <tr>
                                <th colspan="6">THÔNG TIN PHÒNG</th>
                                <th colspan="5" style="text-transform: uppercase;">SỐ {{ type_text}} THÁNG {{ chosen_month_locale }}</th>
                            </tr>
                            <tr>
                                <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template #items="props">
                            <tr>
                                <td class="text-no-wrap">{{ props.index +1 }}</td>
                                <td class="text-no-wrap">{{ props.item.room_id }}</td>
                                <td class="text-center text-no-wrap">
                                    <span :class="['v-badge', props.item.is_valid_contract ? 'primary' : 'warning']">
                                        {{ props.item.is_valid_contract ? "Có người" : "Trống"}}
                                    </span>
                                </td>
                                <td class="text-center text-no-wrap">{{ props.item.customer_count }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.washing_machine ? "Có" : "Không" }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.air_conditioner ? "Có" : "Không" }}</td>
                                <td v-if="(props.item.start_count || props.item.start_count === 0) && props.item.is_valid_contract" style="cursor: pointer" class="text-right">
                                    <v-edit-dialog
                                        large
                                        lazy
                                        @save="updateBill(props.item, 'start')"
                                        @open="props.item.start_count_new = props.item.start_count"
                                        
                                    >
                                        {{ props.item.start_count }}
                                        <template v-slot:input>
                                            <v-text-field
                                                v-model.number="props.item.start_count_new"
                                                :label="`Số ${type_text}`"
                                                single-line
                                            ></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else>{{ props.item.start_count }}</td>
                                <template v-if="(props.item.start_count || props.item.start_count === 0) && props.item.is_valid_contract">
                                    <td v-if="props.item.is_disabled" style="cursor: pointer" class="text-right">
                                        <v-edit-dialog
                                            large
                                            lazy
                                            @save="updateBill(props.item, 'end')"
                                            @open="props.item.end_count_new = props.item.end_count"
                                        >
                                            {{ props.item.end_count }}
                                            <template v-slot:input>
                                                <v-text-field
                                                    v-model.number="props.item.end_count_new"
                                                    :label="`Số ${type_text}`"
                                                    single-line
                                                ></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                    </td>
                                    <td v-else class="text-no-wrap" style="max-width: 100px">
                                        <!-- // Cuối kì -->
                                        <v-text-field
                                            v-model.number="props.item.end_count"
                                            min="0"
                                            @input="updateRoomDiff(props.item)"
                                            type="number"
                                        ></v-text-field>
                                    </td>
                                </template>
                                <td v-else>{{ props.item.end_count || props.item.end_count == 0  ? props.item.end_count : props.item.start_count }}</td>
                                <td class="text-left text-no-wrap">{{props.item.diff}}</td>
                                
                                <!-- Note -->
                                <template v-if="props.item.start_count || props.item.start_count === 0 ">
                                    <td style="cursor: pointer, width: 200px" class="text-right">
                                        <v-edit-dialog
                                            large
                                            lazy
                                            @save="updateNote(props.item, props.index)"
                                            @open="props.item.note_new = props.item.note"
                                        >
                                            {{ props.item.note }}
                                            <template v-slot:input>
                                                <v-text-field
                                                    v-model="props.item.note_new"
                                                    :label="`Ghi chú`"
                                                    single-line
                                                ></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                    </td>
                                    <!-- <td v-else class="text-no-wrap" style="max-width: 200px">
                                        <v-text-field
                                            v-model="props.item.note"
                                        ></v-text-field>
                                    </td> -->
                                </template>
                                <td v-else></td>
                            </tr>
                        </template>
                        <template #no-data>
                            Chưa có thông tin
                        </template>
                    </v-data-table>
                    <div class="text-center pb-3">
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="dialog = true"
                            color="primary"
                        >
                            Lưu thông tin {{ type_text }}
                        </v-btn>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-dialog
        v-model="dialog"
        max-width="60%"
    >
        <app-card>
            <h4>NHẬP NGÀY GHI {{ type_text.toUpperCase() }}</h4>
            <v-form ref="form">
                <v-layout row wrap justify-center>
                    <v-flex xs12 md6>
                        <v-menu
                            :close-on-content-click="false"
                            v-model="menu_date_check"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                        >
                            <v-text-field
                                slot="activator"
                                v-model="date_check"
                                label="Ngày ghi"
                                :disabled="loading.submit"
                                prepend-icon="event"
                                readonly
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                            <v-date-picker locale="vi-VI" v-model="date_check" @input="menu_date_check = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-btn
                        :loading="loading.submit"
                        :disabled="loading.submit"
                        @click="submit"
                        color="primary"
                    >
                        XÁC NHẬN
                    </v-btn>
                </v-layout>
            </v-form>
        </app-card>
    </v-dialog>
    <print-portal layout="landscape" :open="print_electric_water" @close="print_electric_water = false">
        <print-electric-water
            :chosen_month_locale="chosen_month_locale"
            :type_text="type_text"
            :room_data="items"
        ></print-electric-water>
    </print-portal>
</div>
</template>
<script>
import { buildParamQuery, formatTimeServer, dayDiff, deepCopy } from '../../helpers/helpers';
import { list_building } from '../../constants/db-config'
import api from "../../api";
import XLSX from 'xlsx';
import ExportCsvButton from '../../components/ExportExcel/ExportCsvButton'
import PrintPortal from '../../components/Print/PrintPortal'
import PrintElectricWater from '../../components/Print/PrintElectricWater'
import { handleData } from './handleDienNuoc'

export default {
    name: 'bang-dien-nuoc',
    components: {
        ExportCsvButton,
        PrintPortal,
        PrintElectricWater
    },
    data(){
        return {
            headers: [
                { text: "STT", align: "left", sortable: true, value: "index" },
                { text: "Số Phòng", align: "left", sortable: true, value: "room_id" },
                { text: "Trạng thái phòng", align: "center", sortable: false, value: "room_id" },
                { text: "Người Ở", align: "center", sortable: true, value: "customer_count" },
                { text: "Máy Giặt", align: "center", sortable: true, value: "is_washing_machine" },
                { text: "Máy Lạnh", align: "center", sortable: true, value: "is_air_conditioner" },
                { text: "Đầu Kì", align: "left", sortable: true, value: "start_count" },
                { text: "Cuối Kì", align: "left", sortable: true, value: "end_count" },
                { text: "Tiêu Thụ", align: "left", sortable: true, value: "diff_count" },
                { text: "Ghi Chú", align: "center", sortable: true, value: "note" },
            ],
            items: [],
            loader: false,
            rowPerPage: [{"text":"Tất cả","value":-1}, 10,20,50,100],
            chosen_month_locale: '',
            chosen_building: 'BN',
            list_building,
            loading: {
                submit: false
            },
            date_check: '',
            menu_date_check: false,
            menu_month_picker: false,
            chosen_month: new Date().toISOString().substr(0, 7),
            input_excel: [],
            dialog: false,
			rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
            },
            search: "",
            print_electric_water: false
        }
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        type(){
            return this.$route.meta.type
        },
        type_text (){
            return this.type === "E" ? "điện" : "nước"
        },
        role(){
            return this.$store.state.auth.role
        }
        
    },
    watch: {
		chosen_month: {
			handler: function (nv){
				this.getData()
				this.chosen_month_locale = formatTimeServer(nv + '-01').substring(5)
			},
			immediate: true
        },
        chosen_building(){
            this.getData();
        },
        dialog(nv){
            if (!nv) this.$refs.form.reset();
        },
        type(){
            this.getData();
        },
    },
    created(){
    },
    methods: {
        async getData(){
            this.items = []
            const params = {
                dateMonth: this.chosen_month + '-01',
                type: this.type,
                building: this.chosen_building
            }
            const query = buildParamQuery(params)
            this.loader  = true;
            const data = await api.getBills(query)
            this.loader  = false;
            this.items = deepCopy(this.rooms.filter(room => room.building === this.chosen_building))
            this.items = this.items.map(room => handleData(room, data.data, this.chosen_month));
        },
        async submit(){
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            const list_bills = []
            this.items.forEach(bill => {
                if ((bill.start_count || bill.start_count === 0) && bill.end_count && !bill.end_count_old){
                    list_bills.push({
                        type: this.type,
                        count: bill.end_count,
                        room_id: bill.room_id,
                        building: bill.building,
                        note: bill.note
                    })
                }
            })
            if (!list_bills.length){
                return swal.fire('Thông tin', 'Không có dữ liệu mới được cập nhật', 'info')
            }
            this.loading.submit = true
            this.loader = true
            const data = await api.createBills({ date_check: new Date(this.date_check), data: list_bills})
            this.loader = false
            this.loading.submit = false
            if (data.status == 200){
                this.dialog = false
                swal.fire('Hoàn Thành', data.data.message, 'success')
                this.getData()
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
        },
        updateRoomDiff(item){
            if (item.end_count || item.end_count === 0)
                item.diff =  item.end_count - item.start_count
            else item.diff = 0;
            // this.items = this.items.slice(0)
        },
        onFileSelected: function (e){
            let files = e.target.files, f = files[0];
            let reader = new FileReader();
            let that = this
            reader.onload = function(e) {
                let data = new Uint8Array(e.target.result);
                let arr = new Array();
                for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
                let bstr = arr.join("");

                /* Call XLSX */
                let workbook = XLSX.read(bstr, {
                    type: "binary"
                });
                let first_sheet_name = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[first_sheet_name];
                that.input_excel = XLSX.utils.sheet_to_json(worksheet, {
                    raw: true
                });
                that.createDataFromExcel()
            };
            reader.readAsArrayBuffer(f);
        },
        createDataFromExcel: async function (){
            const list_bills = []
            this.input_excel.forEach(bill => {
                list_bills.push({
                    type: 'E',
                    count: bill.electric_count,
                    room_id: bill.room_id,
                    building: bill.building,
                    date_check: new Date(this.handleCustomDate(bill.date_check))
                })
                list_bills.push({
                    type: 'W',
                    count: bill.water_count,
                    room_id: bill.room_id,
                    building: bill.building,
                    date_check: new Date(this.handleCustomDate(bill.date_check))
                })
            })
            this.loading.submit = true
            this.loader = true
            const data = await api.createBills({ date_check: new Date(this.date_check), data: list_bills})
            if (data.status == 200){
                this.getData()
                swal.fire('Hoàn Thành', data.data.message, 'success')
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
            this.loader = false
            this.loading.submit = false
        },
        handleCustomDate: function(date){
	        date = date.toString()
            let year = date.slice(0, 4)
            let month = date.slice(4,6)
            let d = date.slice(6,8)
            return `${year}-${month}-${d}`
        },
        updateBill: async function(bill, type) {
            console.log(bill);
            const id = bill[`${type}_count_id`];
            const count = bill[`${type}_count_new`] !== undefined ? bill[`${type}_count_new`] : bill[`${type}_count`];
            const note = type == "end" ? bill.note_new : undefined

            this.loader = true
            this.loading.submit = true
            const data = await api.updateReceipt(`/bills/${id}`, {
                count, note,
                is_start_count: type == "start"
            })
            this.loader = false
            this.loading.submit = false
            if (data.status === 200){
                bill[`${type}_count`] = count
                bill.note = note
                this.updateRoomDiff(bill)
                swal.fire('Hoàn Thành', data.data.message, 'success')
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
        },
        exportCSV: function(){
			const rows = this.items.map((item, index) => {
				return {
					"STT": index + 1,
					"Tòa nhà": item.building,
					"Số phòng": item.room_id,
					"Người ở": item.customer_count,
					"Máy giặt": item.washing_machine ? "Có" : "Không" ,
					"Máy lạnh": item.air_conditioner ? "Có" : "Không",
					"Đầu kì": item.start_count,
					"Cuối kì": item.end_count ? item.end_count : '',
					"Tiêu thụ": item.diff ? item.diff : '',
					"Ghi chú": item.note
				}
			})
			this.export_csv.rows = rows;
			this.export_csv.title = `${this.chosen_month}-${this.chosen_building}-${this.type === "E" ? "dien" : "nuoc"}`;
			this.export_csv.trigger = !this.export_csv.trigger;
        },
        showPrintTab: async function (){
            if (this.print_electric_water) {
                this.print_electric_water = false;
                await this.$nextTick();
            }
            this.print_electric_water = true;
        },
        updateNote(item, index){
            if (item.end_count_id)
                this.updateBill(item, 'end');
            else {
                item.note = item.note_new;
                this.items.splice(index, 1, item);
            }
        }
    }
}
</script>

